module.exports = __webpack_public_path__ + "img/t2-headshot.c95b1ea1.png";